module.exports = __webpack_public_path__ + "img/2PVRActivateIT.e35b189c.png";